export default __webpack_public_path__ + "static/media/whatsapp.c664b8da.png";